import { useState } from 'react';
import { RachelFeedbackProblemType } from '../../../../../../../../../../services/modules/rachelChats/rachelChats.types';

export interface RachelFeedbackSubmitParams {
  comment: string;
  problemType: RachelFeedbackProblemType | null;
}

interface UseRachelMessageFeedbackModalParams {
  initialComment: string | null;
  initialProblemType: RachelFeedbackProblemType | null;
  onSubmit: (params: RachelFeedbackSubmitParams) => void;
  onClose: () => void;
}

export const useRachelMessageFeedbackModal = ({
  initialComment,
  initialProblemType,
  onSubmit,
  onClose,
}: UseRachelMessageFeedbackModalParams) => {
  const [comment, setComment] = useState(initialComment ?? '');
  const [lastInitialComment, setLastInitialComment] = useState(initialComment);
  const [problemType, setProblemType] = useState<RachelFeedbackProblemType | ''>(
    initialProblemType ?? '',
  );
  const [lastInitialProblemType, setLastInitialProblemType] = useState(initialProblemType);
  const [isDiscardConfirmOpen, setIsDiscardConfirmOpen] = useState(false);

  if (initialComment !== lastInitialComment) {
    setLastInitialComment(initialComment);
    setComment(initialComment ?? '');
  }

  if (initialProblemType !== lastInitialProblemType) {
    setLastInitialProblemType(initialProblemType);
    setProblemType(initialProblemType ?? '');
  }

  const hasUnsavedComment = comment !== (initialComment ?? '');

  const handleSubmit = () => {
    onSubmit({ comment, problemType: problemType || null });
    onClose();
  };

  const requestClose = () => {
    if (!hasUnsavedComment) {
      onClose();
      return;
    }

    setIsDiscardConfirmOpen(true);
  };

  const keepEditing = () => setIsDiscardConfirmOpen(false);

  const discardChanges = () => {
    setIsDiscardConfirmOpen(false);
    onClose();
  };

  const handleExited = () => {
    setIsDiscardConfirmOpen(false);
    setComment(initialComment ?? '');
    setProblemType(initialProblemType ?? '');
  };

  return {
    comment,
    setComment,
    problemType,
    setProblemType,
    isDiscardConfirmOpen,
    handleSubmit,
    requestClose,
    keepEditing,
    discardChanges,
    handleExited,
  };
};
